import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { trustResourceUrl } from "@shared/helpers/SafeUrlHelper";

@Component({
    selector: "my-gcal-widget-wrapper",
    templateUrl: "../fullpage-iframe/fullpage-iframe.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["../fullpage-iframe/fullpage-iframe.component.scss"]
})
export class GCalWidgetWrapperComponent {
    public embedUrl: SafeUrl = null;

    constructor(activatedRoute: ActivatedRoute, sanitizer: DomSanitizer) {
        const params: any = activatedRoute.snapshot.queryParams;
        const embedUrl =
            "https://calendar.google.com/calendar/embed?src=" + encodeURIComponent(params.calendarId);
        this.embedUrl = trustResourceUrl(sanitizer, embedUrl);
    }
}
